import { render, staticRenderFns } from "./TkCxr.vue?vue&type=template&id=224e67b9&scoped=true&"
import script from "./TkCxr.vue?vue&type=script&lang=js&"
export * from "./TkCxr.vue?vue&type=script&lang=js&"
import style0 from "./TkCxr.vue?vue&type=style&index=0&id=224e67b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e67b9",
  null
  
)

export default component.exports